import cashierActions from '../actions/cashier';
import memberActions from '../actions/member';
import messageActions from '../actions/message';
import surveyActions from '../actions/survey';
import promotionActions from '../actions/promotion';
import campaignActions from '../actions/campaign';

const refreshHelpers = {};

refreshHelpers.refetchPath = (dispatch, path, vendorApiKey, locationApiKey) => {
  if (locationApiKey === '') {
    dispatch(surveyActions.clearSurvey());
    dispatch(memberActions.clearMember());
    dispatch(cashierActions.clearCashier());
    dispatch(promotionActions.clearPromotion());
    dispatch(campaignActions.clearCampaign());
  } else {
    dispatch(messageActions.clearMessages());
    if (path === '/surveys') {
      dispatch(surveyActions.list(vendorApiKey, locationApiKey))
    } else if (path === '/members') {
      dispatch(memberActions.list(vendorApiKey, locationApiKey))
    } else if (path === '/cashiers') {
      dispatch(cashierActions.list(vendorApiKey, locationApiKey))
    } else if (path === '/plans') {
      dispatch(promotionActions.list(vendorApiKey, locationApiKey))
    } else if (path === '/one-time-text' || path === '/auto-campaigns') {
      dispatch(campaignActions.list(vendorApiKey, locationApiKey))
    }
  }
}

export default refreshHelpers;



/** WEBPACK FOOTER **
 ** ./src/helpers/Refresh.js
 **/